export default {
    key:'global_admin',
    dashboard: {
        component:'MarketIndex',
        links: {
            sidebar:[
                {
                    icon:'fas fa-fw fa-tachometer-alt',
                    text:'Market Admins',
                    route:'/global_admin',
                    active:'marketadmins'
                },
                {
                    icon:'fa fa-user-cog',
                    text:'settings',
                    route:'/settings',
                    active:'settings'
                }
            ]
        }
    }
}